export default __webpack_public_path__ + "static/media/driving.8ac87366.mp3";